import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { SingleLineEllipsis, ProductiveHeading07 } from 'components/styles';

const Title = styled.div`
  ${ProductiveHeading07};
  ${SingleLineEllipsis};
`;
const Actions = styled.div``;

const TitleWrapper = styled.div<{ hasActions: boolean }>`
  display: flex;

  ${Title} {
    width: 100%;
  }

  ${ifProp(
    'hasActions',
    css`
      ${Title} {
        width: 85%;
      }
      ${Actions} {
        width: 15%;
      }
    `,
  )};
`;

const ContentWrapper = styled.div``;

const Wrapper = styled.section`
  background-color: var(--white-100);
  box-shadow: var(--shadow-02);
  height: 100%;
  padding: var(--spacing-05);

  ${TitleWrapper} {
    padding-bottom: var(--spacing-04);
  }
`;

const TitleComponent: FC<{
  text: ReactNode;
  actions?: ReactNode;
}> = ({ text, actions }) => (
  <TitleWrapper hasActions={actions != null}>
    <Title>{text}</Title>
    <Actions>{actions}</Actions>
  </TitleWrapper>
);

type BaseWidget = typeof Wrapper & {
  Title: typeof TitleComponent;
  Content: typeof ContentWrapper;
};

const BaseWidget: BaseWidget = Wrapper as BaseWidget;

BaseWidget.Title = TitleComponent;
BaseWidget.Content = ContentWrapper;

export { BaseWidget, TitleComponent as Title };
